





































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { mdiPlus } from '@mdi/js'

import MainPanel from '@/components/MainPanel.vue'

import BackgroundImage from '@/store/current/backgroundImage.ts'
import Categories from '@/store/current/categories.ts'
import Composition from '@/store/current/composition.ts'
import PointsSelection from '@/store/current/pointsSelection.ts'
import Points from '@/store/current/points.ts'

const backgroundImage = getModule(BackgroundImage)
const categories = getModule(Categories)
const composition = getModule(Composition)
const pointsSelection = getModule(PointsSelection)
const points = getModule(Points)

@Component({
  components: {
    MainPanel
  }
})
export default class Home extends Vue {
  // annotate refs type
  $refs!: {
    container: HTMLElement,
    firstcol: HTMLElement
  }

  // lifecycle hook
  mounted () {
    // Init the composition
    composition.initWithSomething()
  }

  get buttonIcon (): string {
    return mdiPlus
  }
  get widthGetter (): () => number {
    return () => this.$refs.firstcol ? this.$refs.firstcol.clientWidth : 300
  }
  get heightGetter (): () => number {
    return () => this.$refs.container ? this.$refs.container.clientHeight : 150
  }

  get selectedPointsText (): string {
    return `${pointsSelection.size} ${pointsSelection.size === 1 ? 'point' : 'points'}`
  }
  get showBanner (): boolean {
    return pointsSelection.size > 0
  }

  // methods
  cancelSelection () {
    pointsSelection.clear()
  }
  deleteSelection () {
    points.deleteSet(pointsSelection.asSet)
    pointsSelection.clear()
  }
  async addPoint () {
    points.postRandom(await categories.nextId())
  }
}
